import { render, staticRenderFns } from "./NoticeDeleteNode.vue?vue&type=template&id=2ccb3f24&scoped=true&"
import script from "./NoticeDeleteNode.vue?vue&type=script&lang=js&"
export * from "./NoticeDeleteNode.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDeleteNode.vue?vue&type=style&index=0&id=2ccb3f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb3f24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDialog,
})
